import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import { UserTypeEnum } from '@/models/User';
import PageTitle from '@/components/ui/custom/PageTitle';
import HeadTitle from '@/components/ui/custom/HeadTitle';
import CoursesPathList from '@/components/ui/custom/dataDisplay/course/coursesList/CoursesPathList';
import { createLesson } from '@/data/services/lessonServices';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import alert from '@/utils/shared/alert';
import { getErrorMessage } from '@/utils/getErrorMessage';
import ModalBank, {
  ModalBankButton,
} from '@/components/ui/custom/modals/ModalBank/ModalBank';
import useToggle from '@/data/hook/useToggle';
import { ROUTES } from '@/utils/routes';

export default function AdminCoursesView() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'coursesView.admin',
  });

  const {
    isOpen: isBankModalOpen,
    open: openModal,
    close: closeModal,
  } = useToggle();
  const navigate = useNavigate();
  const {
    mutate: createNewDetachedLesson,
    isPending: isCreatingNewDetachedLesson,
  } = useMutation({
    mutationFn: createLesson,
    onSuccess: lesson => {
      navigate(ROUTES.LESSONS.DETACHED.EDIT(lesson.id));
    },
    onError: error => {
      alert.error(getErrorMessage(error));
    },
  });

  return (
    <div className="flex flex-col gap-6">
      <HeadTitle routeInfo={t('courses')} />
      <div className="flex justify-between lg:w-full items-center">
        <PageTitle headingText={t('courses')} position="mb-0 md:mb-0" />
        <div className="flex gap-3 items-center">
          <ModalBankButton
            mode="lessons"
            onClick={openModal}
            color="custom"
            className="flex-row-reverse font-600 text-secondary gap-1 mr-7 lg:mr-0"
          />
          <ComponentGuard
            roles={[UserTypeEnum.SUPER_ADMIN, UserTypeEnum.CONTENT_CREATOR]}
          >
            {/* TODO: ter uma forma de contornar problema de criar lixo no banco de dados */}
            <MainButton
              onClick={() => createNewDetachedLesson({ name: t('newLesson') })}
              icon={<PlusIcon />}
              text={t('newLesson')}
              color="custom"
              className="flex-row-reverse font-600 text-primary gap-1 mr-7 lg:mr-0"
              loading={isCreatingNewDetachedLesson}
            />
            <MainButton
              href="/courses/studio"
              icon={<PlusIcon />}
              text={t('newCourse')}
              color="custom"
              disabled={isCreatingNewDetachedLesson}
              className="flex-row-reverse font-600 text-primary gap-1 mr-7 lg:mr-0"
            />
          </ComponentGuard>
        </div>
        <ModalBank
          visible={isBankModalOpen}
          onClose={closeModal}
          initial="lessons"
        />
      </div>
      <CoursesPathList />
    </div>
  );
}
